<template>
  <div class="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm sm:p-8">
    <h3 class="text-lg font-semibold text-gray-900">
      {{ t('company.legal_name') }}
    </h3>
    <h4 class="mt-6 text-sm font-semibold uppercase tracking-wide text-gray-500">
      {{ addressHeading || t('contact.address_heading') }}
    </h4>
    <p class="mt-2 whitespace-pre-line text-gray-700">
      {{ t('company.address') }}
    </p>
    <p class="mt-3 text-sm text-gray-600">
      {{ t('company.mailing_note') }}
    </p>
    <h4 class="mt-6 text-sm font-semibold uppercase tracking-wide text-gray-500">
      {{ t('contact.email_heading') }}
    </h4>
    <p class="mt-2">
      <a
        class="font-medium text-primary-600 hover:text-primary-700 hover:underline"
        :href="`mailto:${contactEmail}`"
      >{{ t('company.email_label') }}: {{ contactEmail }}</a>
    </p>
    <p class="mt-4 text-sm text-gray-600">
      {{ t('company.capital') }}
    </p>
    <p class="text-sm text-gray-600">
      {{ t('company.corp_no') }}
    </p>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

const contactEmail = 'admin@rideblink.net'

defineProps<{
  /** Override default "Address" section title (e.g. on contact page) */
  addressHeading?: string
}>()
</script>
